export default "__VITE_ASSET__DOpO7YAs__"